<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Bg8atc/tc-custom/9781497655508.jpg?1725420214303" alt="This image is the cover for the book Hunt with the Hounds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hunt with the Hounds
      </h1>
      <p class="bookDescription body article font2">
        <b>When murder descends on a small Southern town, nothing is more dangerous than telling the truth </b><br/><br/>Ernestine Baily was killed at dusk on a cold fall day as fog and darkness rolled over Hollow Hill. Five months later, her husband, Jed, whom she accused of the crime, stands trial. But in the small Virginia town of Bedford, many question his culpability, among them the murder’s lone witness: Sue Poore. Sue’s testimony ensures Jed’s freedom—something the local paper quickly seizes on as evidence of a scandalous romance. But beyond causing her to suffer this indignity, Sue’s avowal makes her a marked woman, targeted by a local policeman as the next best suspect, and by a mysterious gunman whose second bullet may not miss.<br/> <br/>In a town like Bedford, almost anyone can look guilty, and when Sue becomes caught between three men—two vying for her heart and one for her imprisonment—she knows that the real murderer sits quietly in their midst.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mignon G. Eberhart
      </h2>
      
      <p class="authorDescription body article">Mignon G. Eberhart (1899&ndash;1996) wrote dozens of mystery novels over nearly sixty years. Born in Lincoln, Nebraska, she began writing in high school, swapping English essays with her fellow students in exchange for math homework. She attended Nebraska Wesleyan University, and in the 1920s began writing fiction in her spare time, publishing her first novel,&#160;<I>The Patient in Room 18</I>, in 1929. With the follow-up,&#160;<I>While the Patient Slept</I>&#160;(1931), she won a $5,000 Scotland Yard Prize, and by the end of the 1930s she was one of the most popular female mystery writers on the planet.<BR />&#160;<BR />Before Agatha Christie ever published a Miss Marple novel, Eberhart wrote romantic crime fiction with female leads. Eight of her books, including&#160;<I>While the Patient Slept</I>&#160;and&#160;<I>Hasty Wedding&#160;</I>(1938), were adapted for film. Elected a Mystery Writers of America Grand Master in 1971, Eberhart continued publishing roughly a book a year until the 1980s. Her final novel,&#160;<I>Three Days for Emeralds</I>, was published in 1988.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?229257aa